import { render, staticRenderFns } from "./FormAddTemplates.vue?vue&type=template&id=2c3fd228"
import script from "./FormAddTemplates.vue?vue&type=script&lang=js"
export * from "./FormAddTemplates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports